import { t } from '@lingui/core/macro';
import { getAuthenticationModeTitle } from 'app/domains/esigning/utils';
export const getAuthenticationModeLabel = (authenticationMode) => {
    if (authenticationMode) {
        return getAuthenticationModeTitle(authenticationMode);
    }
    return t({ message: 'Simple Signing', comment: 'Message for signatory with simple signing' });
};
